import merge from 'lodash/merge';
import { handleActions } from 'redux-actions';

import { addEntities, deleteEntities } from 'shared/store/modules/entities';
import { createScheduleResponse } from 'shared/store/modules/schedules/actions';

const defaultState = {};

export default handleActions(
  {
    [addEntities]: {
      next: (state, { payload }) => {
        return merge({}, state, payload.entities.rateTypes);
      }
    },

    [deleteEntities]: {
      next: (state, { payload }) => {
        const newState = Object.assign({}, state);
        delete newState[payload.id];
        return newState;
      }
    },

    [createScheduleResponse]: {
      next: (state, { payload: { entities, result } }) => {
        const { rateTypeId } = entities.schedules[result];

        return {
          ...state,
          [rateTypeId]: {
            ...state[rateTypeId],
            schedules: [...state[rateTypeId].schedules, result]
          }
        };
      }
    }
  },

  defaultState
);
